/**
 * Optional long-task observer, active only with ?perf=1 in the URL. With the flag
 * absent nothing is created or registered (no cost, no behaviour change).
 */

export interface LongTaskStats {
  count: number
  maxMs: number
  totalMs: number
}

export function perfEnabled(search: string): boolean {
  try {
    return new URLSearchParams(search).get('perf') === '1'
  } catch {
    return false
  }
}

export function recordLongTask(stats: LongTaskStats, durationMs: number): LongTaskStats {
  return {
    count: stats.count + 1,
    maxMs: Math.max(stats.maxMs, durationMs),
    totalMs: stats.totalMs + durationMs,
  }
}

/** Returns a stop function, or null when disabled or unsupported. */
export function startLongTaskObserver(
  search: string = typeof location === 'undefined' ? '' : location.search,
): (() => void) | null {
  if (!perfEnabled(search)) return null
  if (typeof PerformanceObserver === 'undefined') return null
  let stats: LongTaskStats = { count: 0, maxMs: 0, totalMs: 0 }
  let observer: PerformanceObserver
  try {
    observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) stats = recordLongTask(stats, entry.duration)
      console.info(
        `[perf] longtask jumlah=${stats.count} maks=${stats.maxMs.toFixed(0)}ms total=${stats.totalMs.toFixed(0)}ms`,
      )
    })
    observer.observe({ type: 'longtask', buffered: true })
  } catch {
    return null
  }
  return () => observer.disconnect()
}
